import React from "react";
//#region types
import { ChartContainerProps } from "models/propTypes/chartProps";
//#endregion
//#region components
import { ErrorBoundary } from "components/error";
import ChartContainerInner from "./chartContainerInner";
//#endregion

const ChartContainer: React.FC<ChartContainerProps> = (props) => {
  return (
    <ErrorBoundary>
      <ChartContainerInner {...props} />
    </ErrorBoundary>
  );
};

export default ChartContainer;
